var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.5.917C16.375.917.917 16.376.917 35.5c0 19.125 15.458 34.584 34.583 34.584S70.083 54.624 70.083 35.5C70.083 16.376 54.625.917 35.5.917zm8.957 20.75L35.5 30.624l-8.957-8.957-4.876 4.876 8.957 8.957-8.957 8.957 4.876 4.877 8.957-8.957 8.957 8.957 4.876-4.877-8.957-8.957 8.957-8.957-4.876-4.876zM7.833 35.5c0 15.252 12.416 27.667 27.667 27.667 15.251 0 27.667-12.415 27.667-27.667 0-15.25-12.416-27.666-27.667-27.666C20.25 7.834 7.833 20.249 7.833 35.5z",
    fill: "#D1004A"
  })));
}

var MemoSvgError = /*#__PURE__*/React.memo(SvgError);
export default MemoSvgError;